import React, { useEffect, useState } from 'react'
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { useDispatch } from 'react-redux';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import Loader from '../../components/common/Loader';
import { FiArrowLeft } from 'react-icons/fi'; 

const AddSchool = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        username: "",
        school_name: "",
        password: "",
        email: "",
        mobile: "",
        subdomain: "",
        isAgreeTC: false,
        logo: null,
        banner_image: null
    });
    const [refresh, setRefresh] = useState(false);
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const validateForm = () => {
        let newErrors = {};

        if (!formData.first_name.trim()) {
            newErrors.first_name = "First name is required";
        }

        if (!formData.last_name.trim()) {
            newErrors.last_name = "Last name is required";
        }

        if (!formData.username.trim()) {
            newErrors.username = "Username is required";
        }

        if (!formData.school_name.trim()) {
            newErrors.school_name = "School name is required";
        }

        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$!%&*])[A-Za-z\d@#$!%&*]{8,12}$/;
        if (location.state?.type !== "edit" && !formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password && !passwordRegex.test(formData.password)) {
            newErrors.password =
                "Password must be 8–12 characters, include uppercase, lowercase, number, and special character (@#$!%&*)";
        }

        const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
        if (!formData.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email format (use lowercase letters only)";
        }

        if (!formData.mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = "Mobile number must be 10 digits";
        }

        if (!formData.isAgreeTC) {
            newErrors.isAgreeTC = "You must agree to the terms & conditions";
        }
        if (!formData.logo) {
            newErrors.logo = "School logo is required";
        } else {
            const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
            if (typeof formData.logo !== "string" && !allowedTypes.includes(formData.logo.type)) {
                newErrors.logo = "Only JPG, JPEG, PNG, or WEBP formats are allowed";
            }
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (formData.logo.size > maxSize) {
                newErrors.logo = "Logo size must be less than or equal to 10MB";
            }
        }

        if (!formData.banner_image) {
            newErrors.banner_image = "School banner image is required";
        } else {
            const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
            if (typeof formData.banner_image !== "string" && !allowedTypes.includes(formData.banner_image.type)) {
                newErrors.banner_image = "Only JPG, JPEG, PNG, or WEBP formats are allowed";
            }
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (formData.banner_image.size > maxSize) {
                newErrors.banner_image = "Banner image size must be less than or equal to 10MB";
            }
        }

        const subdomainRegex = /^(?=.*[a-z])[a-z0-9]+$/;
        if (!formData.subdomain.trim()) {
            newErrors.subdomain = "Subdomain is required";
        } else if (!subdomainRegex.test(formData.subdomain)) {
            newErrors.subdomain =
                "Subdomain must contain only lowercase letters and numbers, and cannot be only numbers";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormData({
            ...formData,
            logo: file
        });
    };
    const handleBannerChange = (e) => {
        const file = e.target.files[0]; 
        setFormData({ ...formData, banner_image: file });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if ((name === 'first_name' || name === 'last_name') && !/^[A-Za-z ]*$/.test(value)) {
            return; // Prevent updating the form data if non-alphabetic character is entered
        }
        if(name === 'mobile' && !/^\d*$/.test(value)){
            return;
        }
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoader(true);

        const form = new FormData();
        form.append("first_name", formData.first_name);
        form.append("last_name", formData.last_name);
        form.append("username", formData.username);
        form.append("school_name", formData.school_name);
        form.append("password", formData.password);
        form.append("subdomain", formData.subdomain);
        form.append("email", formData.email);
        form.append("mobile_number", formData.mobile);
        form.append("isAgreeTC", formData.isAgreeTC);
        if (params.id) {
            form.append("id", params.id);
        }
        if (formData.logo) {
            form.append("logo", formData.logo);
        }
        if (formData.banner_image) {
            form.append("banner_image", formData.banner_image);
        }


        Postdata(HttpService.admin_school_add, form).then((res) => {
            if (res.status === 200) navigate("/admin-school");
            dispatch(message(res.message))
            setLoader(false)
        })
        console.log("Submitted as FormData:", formData);

    };
    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.admin_school_show, { id: params.id }).then((res) => {
            if (res.status == 200) {
                setFormData({
                    first_name: res.data.first_name,
                    last_name: res.data.last_name,
                    username: res.data.username,
                    school_name: res.data.name,
                    email: res.data.email,
                    subdomain: res.data.subdomain,
                    mobile: res.data.mobile_number,
                    isAgreeTC: res.data.isAgreeTC,
                    logo: res.data.logo,
                    banner_image: res.data.banner_image
                });
            } else {
                dispatch(message(res.message));
            }
            setLoader(false)
        }
        )
    }

    useEffect(() => {
        if (params.id) {

            fetchData();
        }
    }, [refresh])


    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <div className="p-6 space-y-6 pr-0">

            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <div className="w-full  bg-white  rounded-xl p-6">
                     <div className="flex items-center mb-4 cursor-pointer" onClick={() => navigate('/admin-school')}>
                        <FiArrowLeft className="text-2xl font-bold mb-6 text-gray-800" />
                        <h2 className="text-2xl font-bold mb-6 text-gray-800">School Form</h2>
                    </div>
                    

                    <form onSubmit={handleSubmit} autoComplete="off" className="space-y-5">
                        {/* First & Last Name */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    First Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                    placeholder="Enter first name"
                                />
                                {errors.first_name && <p className="text-red-500 text-sm">{errors.first_name}</p>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Last Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                    placeholder="Enter last name"
                                />
                                {errors.last_name && <p className="text-red-500 text-sm">{errors.last_name}</p>}
                            </div>
                        </div>

                        {/* School Logo */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                School Logo <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="file"
                                accept="image/jpeg,image/png,image/webp"
                                onChange={handleLogoChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2"
                            />
                            {errors.logo && <p className="text-red-500 text-sm">{errors.logo}</p>}
                            {formData.logo && (
                                <div className="mt-2">
                                    <img
                                        src={typeof formData.logo === "string" ? formData.logo : URL.createObjectURL(formData.logo)}
                                        alt="Preview"
                                        className="w-24 h-24 object-cover rounded-lg border"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Banner Upload */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                School Banner <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="file"
                                accept="image/jpeg,image/png,image/webp"
                                onChange={handleBannerChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2"
                            />
                            {errors.banner_image && <p className="text-red-500 text-sm">{errors.banner_image}</p>}
                            {formData.banner_image && (
                                <div className="mt-2">
                                    <img
                                        src={typeof formData.banner_image === "string" ? formData.banner_image : URL.createObjectURL(formData.banner_image)}
                                        alt="Banner Preview"
                                        className="w-full max-h-48 object-cover rounded-lg border"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Username */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Username <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter username"
                            />
                            {errors.username && <p className="text-red-500 text-sm">{errors.username}</p>}
                        </div>

                        {/* School Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                School Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="school_name"
                                value={formData.school_name}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter school name"
                            />
                            {errors.school_name && <p className="text-red-500 text-sm">{errors.school_name}</p>}
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Password <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter password"
                            />
                            {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter email"
                            />
                            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                        </div>

                        {/* Mobile */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Mobile <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="tel"
                                name="mobile"
                                value={formData.mobile}
                                maxLength={12}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter mobile number"
                            />
                            {errors.mobile && <p className="text-red-500 text-sm">{errors.mobile}</p>}
                        </div>

                        {/* SubDomain */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Sub Domain <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="tel"
                                name="subdomain"
                                value={formData.subdomain}
                                onChange={handleChange}
                                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Sub Domain"
                            />
                            {errors.subdomain && <p className="text-red-500 text-sm">{errors.subdomain}</p>}
                        </div>

                        {/* Terms & Conditions */}
                        <div className="flex items-center">
                            <input
                                id="isAgreeTC"
                                name="isAgreeTC"
                                type="checkbox"
                                checked={formData.isAgreeTC}
                                onChange={handleChange}
                                className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                            />
                            <label htmlFor="isAgreeTC" className="ml-2 block text-sm text-gray-700">
                                I agree to the Terms & Conditions <span className="text-red-500">*</span>
                            </label>
                        </div>
                        {errors.isAgreeTC && <p className="text-red-500 text-sm">{errors.isAgreeTC}</p>}

                        {/* Submit Button */}
                        <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                            <button
                                type="submit"
                                className="button-field-primary"
                                style={{ width: "30%" }}
                                disabled={loader}
                            >
                                {loader ? 'Please wait...' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}

export default AddSchool